export const formatCurrency = ({ amount, currency, convertAmount }) => {
  const convertedAmount = convertAmount(amount, currency);
  return `${new Intl.NumberFormat("vi-VN", {
    maximumFractionDigits: 0,
  }).format(convertedAmount)} ${currency}`;
};
